import { createRoute } from '@tanstack/react-router';
import { layoutRoute } from '@/router/root-routes.tsx';
import { useEffect, useState } from 'react';
import { AppBreadcrumbs } from '@/components/app/app-breadcrumbs.tsx';
import { usePageProps } from '@/hooks/use-page-props.ts';

export const privacyRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/privacy-policy',
  component: PrivacyPage,
});

function PrivacyPage() {
  usePageProps({
    title: 'Privacy Policy',

  })
  const [content, setContent] = useState('');
  useEffect(() => {
    fetch('/privacy-content.html')
      .then((res) => res.text())
      .then((text) => setContent(text));

    // Add the class when the component mounts
    document.body.classList.add('privacy-page');

    // Return a cleanup function to remove the class when the component unmounts
    return () => {
      document.body.classList.remove('privacy-page');
    };
  }, []);
  return (
    <div className="max-w-6xl mx-auto">
      <AppBreadcrumbs items={[{ text: 'Home', href: '/' }, { text: 'Privacy Policy' }]} />
      <h1 className="uppercase text-center font-medium mb-8">Privacy Policy</h1>
      <div className='content' dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
}
